module.exports = __webpack_public_path__ + "static/media/468x60_0025_ro.524e4ece.jpg";